const _pathList = {
    checkUserInformation: (userName, password) => {
        return {
            method: 'post',
            url: 'api/check_user_information',
            data: {
                user_name: userName,
                password: password
            },
            headers: {
                'User-Token': ''
            }
        };
    },
    loginOut: () => {
        return {
            method: 'post',
            url: 'api/login_out'
        };
    },
    checkUserloginStatus: () => {
        return {
            method: 'post',
            url: 'api/check_userlogin_status'
        };
    },
    getQuizList: (params) => {
        return {
            method: 'post',
            url: 'api/web_quiz_list',
            data: params
        };
    },
    getQuizInfo: (id) => {
        return {
            method: 'post',
            url: 'api/get_quiz_info',
            data: {
                article_id: id
            }
        };
    },
    addArticle: (form) => {
        return {
            method: 'post',
            url: 'api/add_article',
            data: {
                form: form
            }
        };
    },
    editArticleSave: (form) => {
        return {
            method: 'post',
            url: 'api/edit_article_save',
            data: {
                form: form
            }
        };
    },
    changeStatus: (status, id) => {
        return {
            method: 'post',
            url: 'api/update_quiz_status',
            data: {
                status: status,
                article_id: id
            }
        };
    }
};
export default _pathList;



// WEBPACK FOOTER //
// ./src/common/axios/api.js